import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import queryClient from "reactQuery/client";

import {
  useLoginToQuestionnaire,
  useLogInWithToken,
} from "hooks/queries/useAuth";
import { useIsSurveyParticipant } from "hooks/queries/useIsAdmin";
import useUserData from "hooks/queries/useUserData";
import {
  getSearchParam,
  LocalStorageKey,
  removeSearchParam,
  SearchParamEnum,
  setCookieArray,
  TriggeredPopupEnum,
} from "hooks/utils";
import { logOut } from "shared/client";

export const useIsComingFromInvitationRedirect = () => {
  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  const { data: userData } = useUserData();

  const { isSurveyParticipant } = useIsSurveyParticipant();

  const { mutateAsync: loginWithToken, isLoading: isLoginWithTokenLoading } =
    useLogInWithToken();

  const {
    mutateAsync: loginToQuestionnaire,
    isLoading: isLoginToQuestionnaireLoading,
  } = useLoginToQuestionnaire();

  useEffect(() => {
    setIsLoading(true);

    const authToken = getSearchParam(SearchParamEnum.AUTH_TOKEN);

    const redirectUrl = getSearchParam(SearchParamEnum.REDIRECT_PAGE_PARAM);

    const rfpInvitationToken = getSearchParam(
      SearchParamEnum.RFP_INVITATION_TOKEN
    );

    const companyMemberInvitationToken = getSearchParam(
      SearchParamEnum.COMPANY_MEMBER_INVITATION_TOKEN
    );
    const inviterCompanyId = getSearchParam(SearchParamEnum.INVITER_COMPANY);
    const groupInvitationToken = getSearchParam(
      SearchParamEnum.GROUP_INVITATION_TOKEN
    );

    const questionnairePublicId = getSearchParam(
      SearchParamEnum.QUESTIONNAIRE_PUBLIC_ID
    );

    const autoTriggeredPopup = getSearchParam(
      SearchParamEnum.OPEN_POPUP
    ) as TriggeredPopupEnum | null;

    if (autoTriggeredPopup) {
      console.log("Setting cookie: ", LocalStorageKey.OPEN_POPUP);
      setCookieArray({
        key: LocalStorageKey.OPEN_POPUP,
        value: autoTriggeredPopup,
        type: "add",
      });
      removeSearchParam(SearchParamEnum.OPEN_POPUP);
    }

    if (redirectUrl) {
      console.log("Setting cookie: ", LocalStorageKey.REDIRECT);

      localStorage.setItem(LocalStorageKey.REDIRECT, redirectUrl);
      removeSearchParam(SearchParamEnum.REDIRECT_PAGE_PARAM);
    }

    //RFP Invitation
    if (rfpInvitationToken) {
      console.log("Setting cookie: ", SearchParamEnum.RFP_INVITATION_TOKEN);
      localStorage.setItem(
        LocalStorageKey.RFP_INVITATION_TOKEN,
        rfpInvitationToken
      );
      removeSearchParam(SearchParamEnum.RFP_INVITATION_TOKEN);

      //Company Member Invitation
    } else if (companyMemberInvitationToken && inviterCompanyId) {
      console.log(
        "Setting cookie: ",
        LocalStorageKey.COMPANY_MEMBER_INVITATION_TOKEN
      );

      localStorage.setItem(
        LocalStorageKey.COMPANY_MEMBER_INVITATION_TOKEN,
        companyMemberInvitationToken
      );

      console.log("Setting cookie: ", LocalStorageKey.INVITER_COMPANY_ID);

      localStorage.setItem(
        LocalStorageKey.INVITER_COMPANY_ID,
        inviterCompanyId
      );

      removeSearchParam(SearchParamEnum.COMPANY_MEMBER_INVITATION_TOKEN);
      removeSearchParam(SearchParamEnum.INVITER_COMPANY);

      //Group Invitation
    } else if (groupInvitationToken && inviterCompanyId) {
      console.log("Setting cookie: ", LocalStorageKey.GROUP_INVITATION_TOKEN);

      localStorage.setItem(
        LocalStorageKey.GROUP_INVITATION_TOKEN,
        groupInvitationToken
      );

      console.log("Setting cookie: ", LocalStorageKey.INVITER_COMPANY_ID);

      localStorage.setItem(
        LocalStorageKey.INVITER_COMPANY_ID,
        inviterCompanyId
      );

      removeSearchParam(SearchParamEnum.GROUP_INVITATION_TOKEN);
      removeSearchParam(SearchParamEnum.INVITER_COMPANY);
    }

    if (questionnairePublicId) {
      console.log("Setting cookie: ", LocalStorageKey.QUESTIONNAIRE_PUBLIC_ID);
      localStorage.setItem(
        LocalStorageKey.QUESTIONNAIRE_PUBLIC_ID,
        questionnairePublicId
      );
      removeSearchParam(SearchParamEnum.QUESTIONNAIRE_PUBLIC_ID);
    }

    if (authToken) {
      loginWithToken(authToken);
    }

    if (questionnairePublicId && !authToken) {
      loginToQuestionnaire(questionnairePublicId);
    }

    /// TODO: Refactor this redirect. This is used for individual survey participants to avoid visiting unauthorized pages
    if (isSurveyParticipant && userData) {
      if (!history.location.pathname.includes("/questionnaireresponses")) {
        localStorage.clear();
        window.location.href = "https://pulsemarket.com";
        queryClient.removeQueries();
        logOut();
      }
    }

    if (isLoginWithTokenLoading || isLoginToQuestionnaireLoading) {
      return;
    }

    setIsLoading(false);
  }, [
    history,
    isLoginToQuestionnaireLoading,
    isLoginWithTokenLoading,
    isSurveyParticipant,
    loginToQuestionnaire,
    loginWithToken,
    userData,
  ]);
  return { isLoading };
};
